// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__h0zVS","searchIcon":"SearchBar_searchIcon__qpIIN","searchInput":"SearchBar_searchInput__Qqb1f","clearButton":"SearchBar_clearButton__eVmlH"};